const reducer = (state = {}) => {
    return state;
};

export default reducer;
